module.exports = __webpack_public_path__ + "static/img/product_banner_big_zh.c246717.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_big_zh.png
// module id = m0oF
// module chunks = 34